import { useMutation } from '@tanstack/react-query'
import { isAxiosError } from 'axios'
import { apiClient } from '@/shared/api/apiClient'
import type {
  WeChatAuthorizeResponse,
  WeChatOAuthIntent,
} from './wxLoginScript'

export function useWeChatAuthorize() {
  return useMutation({
    mutationFn: async (input: {
      intent: WeChatOAuthIntent
      returnTo?: string
    }): Promise<WeChatAuthorizeResponse> => {
      const response = await apiClient.post<WeChatAuthorizeResponse>(
        '/v1/auth/wechat/authorize',
        input
      )
      return response.data
    },
    throwOnError: false,
  })
}

export function isWeChatAuthUnavailableError(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 404
}
